// GlowStrike ES — sticky-header reveal, matching the competitor's updateHeader() logic in
// theme.js: hide header on scroll-down past its own height, reveal on scroll-up, skip while a
// menu <details> is open. Re-implemented from scratch (not copied) against the same behavior.
(function () {
  var lastScroll = window.scrollY;
  var frame = 0;

  function update() {
    frame = 0;
    var header = document.querySelector('[data-gs-sticky-header]');
    if (!header) return;
    var y = Math.max(window.scrollY, 0);
    var height = header.offsetHeight;
    var hidden = false;

    if (header.dataset.reveal === 'true' && y > height && !header.querySelector('details[open]')) {
      var delta = y - lastScroll;
      if (Math.abs(delta) < 6) return;
      hidden = delta > 0;
    }

    lastScroll = y;
    header.dataset.hidden = String(hidden);
  }

  function queue() {
    if (!frame) frame = window.requestAnimationFrame(update);
  }

  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue);
  update();
})();
